import React, { useState, useEffect } from 'react';
import Card from '../../../components/common/Card';
import logo1 from "../../../assets/dashboard/dot.png"
import logo2 from "../../../assets/dashboard/soldproducts.png"
import { toast } from 'react-toastify';
import { acceptPolicy, accpetByAdmin, declinePolicy, deleteCourseByAdmin, getAllCoursesByAdmin, getAllPolicies } from '../../../services/Admin/admin';
import CourseTable from './CorseTable';

const CoursesComponent = () => {

  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [addedCourse, setAddedCourse] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAcceptModal, setShowAcceptModal] = useState(false);

  const [courseToDelete, setCourseToDelete] = useState(null);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [courseToAssign, setCourseToAssign] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [allCoursesData, setAllCoursesData] = useState()
  const [allCourseLoading, setAllCourseLoading] = useState(false)
  const [assignStaffLoading, setAssignStaffLoading] = useState(false)
  const [searchedCourses, setSearchedCourses] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const [cachedPages, setCachedPages] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingAccept, setLoadingAccept] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);


  const fetchCourseData = async (page = 1, search = '') => {
    setAllCourseLoading(true);

    // Check cache if not searching
    if (!search && cachedPages[page]) {
      setAllCoursesData(cachedPages[page]);
      setCurrentPage(page);
      setAllCourseLoading(false);
      return;
    }

    try {
      const data = await getAllCoursesByAdmin({ page, search });

      if (data?.data) {
        setAllCoursesData(data.data);
        setCurrentPage(page);
        setTotalPages(data.totalPages || 1);

        if (!search) {
          setCachedPages(prev => ({
            ...prev,
            [page]: data.data
          }));
        }
      }
    } catch (error) {
      console.error("Failed to fetch courses:", error);
    } finally {
      setAllCourseLoading(false);
    }
  };

  useEffect(() => {
    fetchCourseData(1)
  }, [])

  const handleDeclineClick = (id) => {
    setCourseToDelete(id);
    setShowDeleteModal(true);
  };

  const handleAcceptClick = (id) => {
    setCourseToDelete(id);
    setShowAcceptModal(true);
  };

  const handleConfirmDecline = async () => {
    setLoadingDelete(true)
    const response = await deleteCourseByAdmin(courseToDelete)
    console.log("resoponse>>",response)
    const updatedCourses = allCoursesData.filter(course => course._id !== courseToDelete);
    setAllCoursesData(updatedCourses);
    if(response?.success){
      toast.success(response?.message)
    }
    setLoadingDelete(false)

    setShowDeleteModal(false);
   
  };

  const handleConfirmAccept = async () => {
    setLoadingAccept(true)
    const response = await accpetByAdmin(courseToDelete)
       console.log("resoponse>>",response)
       const updatedCourses = allCoursesData.map(course => 
         course._id === courseToDelete ? { ...course, isVerified: true } : course
       );
       setAllCoursesData(updatedCourses);
       if(response?.success){
         toast.success(response?.message)
       }
    setLoadingAccept(false)
    setShowAcceptModal(false);
   
  };

  const handleAssignClick = (id) => {
    setCourseToAssign(id);
    setShowAssignModal(true);
    setSelectedStaff([]);
  };



  return (
    <div className="container ">
     
      {
        allCourseLoading ?

          <div className="col-md-12" style={{ height: '40vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div class="spinner-border spinner-border-sm" role="status"></div>
          </div>
          :
          <>

            <CourseTable
              courses={allCoursesData}
              setCourses={setAllCoursesData}
              onDeclinePolicy={handleDeclineClick}
              onAssignStaff={handleAssignClick}
              onAccept={handleAcceptClick}
            />


            <nav className="d-flex justify-content-center mt-4">
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button
                    className="page-link d-flex align-items-center justify-content-center"
                    onClick={() => fetchCourseData(currentPage - 1, isSearching ? searchTerm : '')}
                    disabled={currentPage === 1}
                  >
                    <i className="bi bi-chevron-left"></i>
                  </button>
                </li>

                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                    <button
                      className="page-link"
                      onClick={() => fetchCourseData(page, isSearching ? searchTerm : '')}
                    >
                      {page}
                    </button>
                  </li>
                ))}

                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button
                    className="page-link d-flex align-items-center justify-content-center"
                    onClick={() => fetchCourseData(currentPage + 1, isSearching ? searchTerm : '')}
                    disabled={currentPage === totalPages}
                  >
                    <i className="bi bi-chevron-right"></i>
                  </button>
                </li>
              </ul>
            </nav>
          </>
      }


      {/* Course Details Modal */}
      {isDetailsModalOpen && addedCourse && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content border-0 bg-transparent shadow-none">
              <div className="modal-body p-0">
                {/* <CourseDetails
                  course={addedCourse}
                  onClose={() => setIsDetailsModalOpen(false)}
                /> */}
              </div>
            </div>
          </div>
          <div className="modal-backdrop show"></div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirmation</h5>
                <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this Course?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>
                  Cancel
                </button>
                <button type="button" className="btn btn-danger" onClick={handleConfirmDecline} disabled={loadingDelete}>
                  {
                  loadingDelete ? "loading...": "Delete" }
                  
                </button>
              </div>
            </div>
          </div>
          {/* <div className="modal-backdrop show"></div> */}
        </div>
      )}

      {showAcceptModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirmation</h5>
                <button type="button" className="btn-close" onClick={() => setShowAcceptModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to Accept this Course?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowAcceptModal(false)}>
                  Cancel
                </button>
                <button type="button" className="btn btn-success" onClick={handleConfirmAccept} disabled={loadingAccept}>
                 {
                  loadingAccept ? "loading..." :"Accept"
                 } 
                </button>
              </div>
            </div>
          </div>
          {/* <div className="modal-backdrop show"></div> */}
        </div>
      )}

      {/* Assign Staff Modal */}
     
    </div>
  );
};

export default CoursesComponent;